import { render, staticRenderFns } from "./unitRanking.vue?vue&type=template&id=c660794e&"
import script from "./unitRanking.vue?vue&type=script&lang=js&"
export * from "./unitRanking.vue?vue&type=script&lang=js&"
import style0 from "./unitRanking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports